export default __webpack_public_path__ + "static/topmenu01@2x-689cfcb5093f138748dde2aff7de0382.png";